import React from "react";
import { useSelector } from "react-redux";
import './ConfirmationModal.scss';

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const ConfirmationModal = props => {
    const { text, closeMethod, confirmMethod, confirmButtonText, deleteModal, item, calibrationSet } = props;
    const { t } = useSelector(selector);

    const closeModal = () => {
        closeMethod();
    };

    return(
        <div
            className='confirmationModalBlur'
            onClick={e => {
                if(e.target.className === 'confirmationModalBlur') {
                    closeModal()
                }
            }}
        >
            <div className='confirmationModalWindow'>
                <div className='confirmationModalText'>
                    {deleteModal && item ? text + ' ' + (calibrationSet ? item.setName : item.name) + '?' : text}
                </div>
                <div className='confirmationModalButtonsHolder'>
                    <button
                      className='confirmationModalCancelButton'
                      onClick={e => {
                          e.preventDefault();
                          closeModal();
                      }}
                    >
                        {t.gettext('Cancel')}
                    </button>
                    <button
                      className='confirmationModalConfirmButton'
                      onClick={e => {
                          e.preventDefault();
                          confirmMethod();
                      }}
                    >
                        {confirmButtonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
